import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import SiteHeader from "@/components/SiteHeader";
import { CheckCircle2 } from "lucide-react";

export default function OrderConfirmedPage() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  useEffect(() => {
    api.get(`/orders/${orderId}`).then(({ data }) => setOrder(data)).catch(() => {});
  }, [orderId]);

  return (
    <div className="min-h-screen bg-cream">
      <SiteHeader showNav={false} />
      <main id="main-content" className="max-w-3xl mx-auto px-4 py-16 text-center">
        <CheckCircle2 className="mx-auto text-chocolate" size={48} />
        <p className="k-overline mt-5">Order placed</p>
        <h1 className="page-title mt-2" data-testid="order-confirmed-heading">Thank you. Your next chapter starts here.</h1>
        <p className="text-inkMute mt-3" data-testid="order-confirmation-note">Your draft is being prepared. Return to Your books to view it when it’s ready.</p>

        {order && (
          <div className="k-card text-left mt-10 p-6 sm:p-8" data-testid="order-summary">
            <p className="k-overline mb-3">Summary</p>
            <div className="text-sm text-ink space-y-1.5">
              <p><span className="text-inkMute">Order ID:</span> {order.id.slice(0, 8)}…</p>
              <p><span className="text-inkMute">Product:</span> {order.product_label}</p>
              <p><span className="text-inkMute">For:</span> {order.recipient_name}</p>
              <p><span className="text-inkMute">Status:</span> <span className="capitalize">{order.order_status?.replaceAll("_", " ")}</span></p>
              <p><span className="text-inkMute">Total:</span> ₹{order.total_price.toLocaleString('en-IN')}</p>
            </div>
          </div>
        )}

        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/projects" className="btn-primary" data-testid="order-your-books">Your books</Link>
          <Link to="/" className="btn-ghost" data-testid="back-home">Back to home</Link>
        </div>
      </main>
    </div>
  );
}
